import { useEffect } from "react";
import style from "./DemoLayout.module.css";

function DemoLayout() {
    return (
        <div className={style.container}>
            <div className={style.frame}>
                <div className={style.aspectBox}>
                    <div className={style.content}>
                        <iframe className={style.iframe} src={"https://puffuapp.com/ws/4000/demoKiosk/home"} width={1920} height={1080} border={"none"} />
                    </div>
                </div>
            </div>
        </div>

    );
}

export default DemoLayout;